const QuantityRow = ({
  row,
  index,
  form,
  setForm,
  activityConfig,
  errors,
  setErrors
}) => {

  // =====================================
  // PARSE API CONFIG
  // =====================================

  const sourceDetails =
    activityConfig.source_field_details
      ? JSON.parse(activityConfig.source_field_details)
      : null;

  const disposalDetails =
    activityConfig.disposal_field_details
      ? JSON.parse(activityConfig.disposal_field_details)
      : null;

  const emissionDetails =
    activityConfig.emission_factor_details
      ? JSON.parse(activityConfig.emission_factor_details)
      : null;

  // =====================================
  // DYNAMIC FIELD CONFIG
  // =====================================

  const dynamicField =
    sourceDetails || disposalDetails;

  const fieldLabel =
    dynamicField?.field_label || "Source";

  const availableOptions =
    dynamicField?.options || [];

  // =====================================
  // SELECTED OPTION
  // =====================================

  const selectedOption =
    availableOptions.find(
      (o) =>
        String(o.option_id) ===
        String(row.source_id)
    );

  // =====================================
  // EMISSION FACTOR APPLICABLE?
  // =====================================

  const emissionApplicable =
    activityConfig.is_emission_applicable === 1 &&
    selectedOption?.is_emission_factor_required === 1;

  // =====================================
  // FACTOR VALUE
  // =====================================

  const factorValue =
    emissionApplicable
      ? Number(emissionDetails?.factor_value || 0)
      : 0;

  const factorUnit =
    emissionApplicable
      ? emissionDetails?.emission_factor_unit || ""
      : "";

  // =====================================
  // CALCULATE EMISSION
  // =====================================

  const emission =
    (
      (
        Number(row.value || 0)
        *
        factorValue
      ) / 1000
    ).toFixed(2);

  // =====================================
  // UPDATE ROW
  // =====================================

  const updateRow = (field, value) => {

    const updatedRows = [...form.entries];

    updatedRows[index][field] = value;

    setForm({
      ...form,
      entries: updatedRows
    });

    // CLEAR VALIDATION

    if (field === "source_id") {

      setErrors((prev) => ({
        ...prev,
        [`source_${index}`]: ""
      }));
    }

    if (field === "value") {

      setErrors((prev) => ({
        ...prev,
        [`value_${index}`]: ""
      }));
    }
  };

  // =====================================
  // REMOVE ROW
  // =====================================

  const removeRow = () => {

    const updatedRows =
      form.entries.filter((_, i) => i !== index);

    setForm({
      ...form,
      entries: updatedRows
    });
  };

  // =====================================
  // FILTER USED OPTIONS
  // =====================================

  const usedSources = form.entries
    .filter((_, i) => i !== index)
    .map((e) => String(e.source_id));

  const filteredOptions =
    availableOptions.filter(
      (o) =>
        !usedSources.includes(
          String(o.option_id)
        )
    );

  return (

    <div className="ecf-entry-row">

      <div className="ecf-quantity-row-inline">

        {/* SOURCE / DISPOSAL */}

        <div className="org-form-field ecf-field-with-error">

          <label className="org-field-label">
            {fieldLabel}
            <span className="req"> *</span>
          </label>

          <select
            className={`org-field-input ${
              errors?.[`source_${index}`]
                ? "org-field-input--error"
                : ""
            }`}
            value={row.source_id}
            onChange={(e) => {

              const option =
                availableOptions.find(
                  (o) =>
                    String(o.option_id)
                    ===
                    String(e.target.value)
                );

              updateRow("source_id", e.target.value);

              updateRow(
                "source_name",
                option?.option_value || ""
              );
            }}
          >

            <option value="">
              Select {fieldLabel}
            </option>

            {filteredOptions.map((option) => (

              <option
                key={option.option_id}
                value={option.option_id}
              >
                {option.option_value}
              </option>

            ))}

          </select>

          <div className="org-field-error">
            {errors?.[`source_${index}`] || ""}
          </div>

        </div>

        {/* VALUE */}

        <div className="org-form-field ecf-field-with-error">

          <label className="org-field-label">
            Value
            <span className="req"> *</span>
          </label>

          <input
            type="number"
            placeholder="e.g. 500"
            className={`org-field-input ${
              errors?.[`value_${index}`]
                ? "org-field-input--error"
                : ""
            }`}
            value={row.value}
            onChange={(e) =>
              updateRow("value", e.target.value)
            }
          />

          <div className="org-field-error">
            {errors?.[`value_${index}`] || ""}
          </div>

        </div>

        {/* UNIT */}

        <div className="org-form-field">

          <label className="org-field-label">
            Unit
          </label>

          <input
            className="org-field-input ecf-input-disabled"
            disabled
            value={activityConfig.unit_name}
          />

        </div>

        {/* EMISSION FACTOR */}

        {activityConfig.is_emission_applicable === 1 && (

          <div className="org-form-field">

            <label className="org-field-label">
              Emission Factor
            </label>

            <input
              className="org-field-input ecf-input-disabled"
              disabled
              value={
                factorValue > 0
                  ? `${factorValue} ${factorUnit}`
                  : "0"
              }
            />

          </div>

        )}

        {/* ESTIMATED EMISSION */}

        {activityConfig.is_emission_applicable === 1 && (

          <div className="org-form-field">

            <label className="org-field-label">
              Estimated Emission
            </label>

            <input
              className="org-field-input ecf-input-disabled"
              disabled
              value={`${emission} tCO2e`}
            />

          </div>

        )}

        {/* DELETE */}

        <div className="ecf-delete-inline">

          {form.entries.length > 1 && (

            <button
              type="button"
              className="ecf-remove-btn"
              onClick={removeRow}
            >
              ✕
            </button>

          )}

        </div>

      </div>

    </div>
  );
};

export default QuantityRow;